import {
  Avatar,
  Box,
  Button,
  Card,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { BuyerFound } from './BuyerRegistration';
import { poppins400 } from 'theme/common.style';
import Loading from '../../assets/images/loading.png';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import { SIGNUP_URL } from 'constant/app.config';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';

const BuyerCheckInCard = (props) => {
  let {
    checkInData,
    checkInErrorData,
    clickNewBuyer,
    setAnchorEl,
    tooManyResults,
    propertyid,
    agencyId,
    getListInfo,
    activityfun,
    register,
    setRegister,
    checkin,
    setCheckin,
    setCheckInIndex,
    setSearchCheckInUser,
    buyerSearchLoader,
    setLoadingSubmit,
  } = props;

  const theme = useTheme();

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const [checkInAllLoader, setCheckInAllLoader] = useState(false);

  const getStatusMessage = () => {
    if (tooManyResults)
      return 'Type at least three characters to get filtered results';
    if (checkInErrorData) return 'Buyer not found!';
    if (buyerSearchLoader) return 'Searching...';
    return 'Buyer found';
  };

  return (
    <>
      <Card
        sx={{
          boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
          minHeight: 150,
          maxHeight: '463px',
          minWidth: matchessm ? '100%' : '700px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Grid
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 0 12px 26px',
            gap: '5px',
            position: 'sticky',
            top: 0,
            background: '#fff',
            zIndex: 1,
            borderBottom: '1px solid #eee',
          }}
        >
          <Typography>
            <BuyerFound />
          </Typography>
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontWeight: 500,
              fontSize: '14px',
              color: '#666666',
            }}
          >
            {getStatusMessage()}
          </Typography>
        </Grid>

        {buyerSearchLoader ? (
          <Stack
            direction={matchessm ? 'column' : 'row'}
            alignItems="center"
            spacing={2}
            sx={{ width: '100%', p: 2 }}
          >
            <Skeleton variant="circular" width={40} height={40} />

            <Skeleton
              variant="text"
              width={matchessm ? '100%' : 160}
              height={40}
            />

            <Skeleton
              variant="text"
              width={matchessm ? '100%' : 220}
              height={40}
            />

            <Skeleton
              variant="text"
              width={matchessm ? '100%' : 170}
              height={40}
            />
          </Stack>
        ) : checkInErrorData ? (
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '25px',
            }}
          >
            <Typography
              onClick={() => {
                clickNewBuyer();
              }}
              sx={{
                color: '#5eadda',
                fontFamily: 'poppins',
                fontSize: matchessm ? '12px' : '16px',
                cursor: 'pointer',
              }}
            >
              + Add New User
            </Typography>
          </Grid>
        ) : (
          <Box
            sx={{
              overflowY: 'auto',
              flex: 1,
              px: 2,
            }}
          >
            {checkInData?.userData?.map((user) => (
              <Box key={user?.userId} mt={2}>
                <BuyerCheckInList
                  user={user}
                  propertyid={propertyid}
                  agencyId={agencyId}
                  getListInfo={getListInfo}
                  activityfun={activityfun}
                  setAnchorEl={setAnchorEl}
                  register={register}
                  setRegister={setRegister}
                  setCheckin={setCheckin}
                  checkin={checkin}
                  checkInErrorData={checkInErrorData}
                  setCheckInIndex={setCheckInIndex}
                  setSearchCheckInUser={setSearchCheckInUser}
                  checkInAllLoader={checkInAllLoader}
                  setCheckInAllLoader={setCheckInAllLoader}
                  setLoadingSubmit={setLoadingSubmit}
                />
              </Box>
            ))}
          </Box>
        )}
      </Card>
    </>
  );
};

const BuyerCheckInList = (props) => {
  let {
    user,
    propertyid,
    agencyId,
    getListInfo,
    activityfun,
    setAnchorEl,
    register,
    setRegister,
    setCheckin,
    checkin,
    checkInErrorData,
    setCheckInIndex,
    setSearchCheckInUser,
    checkInAllLoader,
    setCheckInAllLoader,
    setLoadingSubmit,
  } = props;
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const getInitials = (first = '', last = '') =>
    `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();

  const [checkInLoader, setCheckInLoader] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    if (checkInLoader) {
      setCheckInAllLoader(true);
    } else {
      setCheckInAllLoader(false);
    }
  }, [checkInLoader]);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = async (res) => {
    if (isNotEmptyArray(res?.data?.dataForBuyerAdminBinder))
      await Moxoseparationinlisting(
        'dataForVendorAdminBinder',
        res?.data?.dataForBuyerAdminBinder
      ); //1
    if (isNotEmptyArray(res?.data?.dataForABPropertyBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.data?.dataForABPropertyBinder
      ); //2
    if (isNotEmptyArray(res?.data?.dataForABBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.data?.dataForABBinder
      ); //3
    if (isNotEmptyArray(res?.data?.dataForAddComment))
      Moxoseparationinlisting(
        'dataForAddComment',
        res?.data?.dataForAddComment
      ); //4
    if (isNotEmptyArray(res?.data?.dataForViewContractToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForViewContractToDo
      ); //5
    if (isNotEmptyArray(res?.data?.dataForProFeedbackToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForProFeedbackToDo
      ); //6
    if (isNotEmptyArray(res?.data?.dataForIdCheckToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForIdCheckToDo
      ); //7
    if (isNotEmptyArray(res?.data?.dataForBuyerQuestionToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForBuyerQuestionToDo
      ); //8
    if (isNotEmptyArray(res?.data?.dataForOnboardSolToDo))
      Moxoseparationinlisting(
        'dataForAddToDoItem',
        res?.data?.dataForOnboardSolToDo
      ); //9
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //10
    if (isNotEmptyArray(res?.data?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAck', res?.data?.dataForBuyerAck); //11
  };

  const searchDataCheckIn = async (userData) => {
    const inputData = {
      userName:
        userData?.userName?.charAt(0)?.toUpperCase() +
        userData?.userName?.slice(1),
      surName:
        userData?.userSurName?.charAt(0)?.toUpperCase() +
        userData?.userSurName?.slice(1),
      email: userData?.userEmail,
      mobileNo: userData?.userPhone,
      isCheckIn: 1,
      propertyId: propertyid,
      agentId: agencyId,
      userTypeCode: 'Buyer001',
    };

    try {
      setCheckInLoader(true);
      setLoadingSubmit(true);

      const res = await postApiCall(SIGNUP_URL, inputData);
      const { status, heading, message } = res?.data || {};

      setCheckInLoader(false);
      if (status === 1) {
        setAnchorEl('');
        await moxoapis(res);

        if (heading === 'Re-inspection') {
          Swal.fire({
            title: heading || 'Error',
            text: message,
            icon: 'warning',
            confirmButtonText: 'Close',
          });

          getListInfo();
          activityfun();
          setSearchCheckInUser('');
          return;
        }

        await setAnchorEl('');
        setCheckin((prev) => !prev);
        setSearchCheckInUser(userData);
        getListInfo();
        setRegister((prev) => !prev);
        activityfun();
      } else {
        await Swal.fire({
          title: heading || 'Error',
          text: message,
          icon: heading === 'Buyer Verification Required' ? 'warning' : 'error',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      await Swal.fire({
        title: 'Error',
        text: 'Check-In Failed!',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setCheckInLoader(false);
      setLoadingSubmit(false);
    }
  };

  return (
    <>
      <Paper
        key={user.userId}
        elevation={0}
        sx={{
          p: 2,
          mb: 2,
          borderRadius: 2,
          border: '1px solid #eee',
          pointerEvents: checkInAllLoader ? 'none' : 'auto',
          opacity: checkInAllLoader ? 0.6 : 1,
        }}
      >
        <Grid container spacing={2} alignItems="baseline">
          <Grid item xs="auto" display={'flex'} alignItems={'center'} gap={1}>
            <Box sx={{ width: 40, height: 40, position: 'relative' }}>
              <Avatar
                sx={{
                  bgcolor: '#555',
                  color: '#ececec',
                  fontFamily: 'Poppins',
                  width: 40,
                  height: 40,
                }}
              >
                {getInitials(user.userName, user.userSurName)}
              </Avatar>
              {user?.userProfile && !imageError && (
                <Avatar
                  src={user.userProfile}
                  imgProps={{
                    onError: () => setImageError(true),
                    style: { objectFit: 'cover' },
                  }}
                  sx={{
                    width: 40,
                    height: 40,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bgcolor: 'transparent',
                  }}
                />
              )}
            </Box>
            {matchessm && (
              <Typography
                sx={{
                  flex: 1,
                  minWidth: 180,
                  color: '#112347',
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  fontWeight: 500,
                  textAlign: 'left',
                  pr: 2,
                }}
              >
                {user.userName} {user.userSurName}
              </Typography>
            )}
          </Grid>

          <Grid item xs>
            <Stack
              direction={matchessm ? 'column ' : 'row'}
              spacing={matchessm && 1}
              sx={{
                minWidth: 0,
              }}
            >
              <Stack
                direction="column"
                alignItems="flex-start"
                sx={{
                  flex: 1,
                  minWidth: 280,
                  pr: 2,
                }}
              >
                <Typography
                  sx={{
                    display: matchessm && 'none',
                    flex: 1,
                    minWidth: 180,
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 500,
                    textAlign: 'left',
                    pr: 2,
                  }}
                >
                  {user.userName} {user.userSurName}
                </Typography>
                {user?.userInspectedDates?.length > 0 && !checkInErrorData && (
                  <Stack
                    direction="column"
                    alignItems="flex-start"
                    sx={{
                      border: '1px solid #F39800',
                      color: '#F39800',
                      backgroundColor: '#FFF7E9',
                      borderRadius: '6px',
                      padding: '8px 10px',
                      width: '100%',
                      mt: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '12px',
                        mb: 0.5,
                      }}
                    >
                      This buyer has already inspected.
                    </Typography>

                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '12px',
                        fontWeight: 500,
                        color: '#F39800',
                        mb: 0.5,
                      }}
                    >
                      Past Inspections:
                    </Typography>

                    <List sx={{ p: 0, maxHeight: '100px', overflow: 'scroll' }}>
                      {user.userInspectedDates.map((date, idx) => (
                        <ListItem
                          key={idx}
                          disableGutters
                          sx={{
                            py: 0,
                            px: 1,
                          }}
                        >
                          <ListItemText
                            primary={`• ${date}`}
                            primaryTypographyProps={{
                              ...poppins400,
                              fontSize: '12px',
                              color: '#F39800',
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </Stack>
                )}
              </Stack>

              <Typography
                sx={{
                  flex: 1,
                  minWidth: 220,
                  color: '#666666',
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  fontWeight: 500,
                  textAlign: 'left',
                  pr: 2,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {user.userEmail}
              </Typography>

              <Typography
                sx={{
                  flex: 1,
                  minWidth: 150,
                  color: '#666666',
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  fontWeight: 500,
                  textAlign: 'left',
                }}
              >
                {user.userPhone}
              </Typography>
            </Stack>
          </Grid>

          <Grid item xs={12} sm="auto" display="flex" justifyContent="flex-end">
            <Button
              disabled={checkInLoader}
              variant="contained"
              onClick={() => {
                setCheckInIndex('1');
                searchDataCheckIn(user); // Pass the active user
              }}
              sx={{
                px: matchessm ? 1 : 3,
                height: matchessm ? 30 : 40,
                width: { xs: '100%', sm: 'auto' },
                whiteSpace: 'nowrap',
                background: '#4ca4d6',
                textTransform: 'none',
                ':hover': { backgroundColor: '#4ca4d6' },
              }}
            >
              Check In
            </Button>
            {checkInLoader && (
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{
                  height: 40,
                  width: 40,
                  marginLeft: 10,
                }}
              />
            )}
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default BuyerCheckInCard;
